// extracted by mini-css-extract-plugin
export var centeredText = "RichText-module--centeredText--1cb68";
export var richtext = "RichText-module--richtext--1638c";